var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './scss/styles.scss';
import './scss/preloader.scss';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from './services/ApolloService';
var HeaderLoader = lazy(function () { return import('./HeaderLoader'); });
var FooterLoader = lazy(function () { return import('./FooterLoader'); });
var waitForDocumentReady = function () {
    if (document.readyState !== 'loading') {
        init();
    }
    else {
        setTimeout(waitForDocumentReady, 10);
    }
};
function init() {
    var headerEle = document.getElementById('apz-header');
    if (headerEle) {
        // To make the header sticky
        headerEle.style.position = 'sticky';
        headerEle.style.top = '0px';
        headerEle.style.zIndex = '1020';
        // END
        var apolloClientHeader = createApolloClient('aperza-app-search-header');
        createRoot(headerEle).render(_jsx(StrictMode, { children: _jsx(ApolloProvider, __assign({ client: apolloClientHeader }, { children: _jsx(HeaderLoader, {}) })) }));
    }
    var footerEle = document.getElementById('apz-footer');
    if (footerEle) {
        footerEle.dataset.service = 'search';
        footerEle.dataset.issociallink = 'false';
        footerEle.dataset.ismultilang = 'false';
        createRoot(footerEle).render(_jsx(StrictMode, { children: _jsx(FooterLoader, {}) }));
    }
}
waitForDocumentReady();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
